export const locale = "da";
